import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
	AUTH_TOKEN,
	SIGNIN,
	SIGNOUT,
	SIGNUP,
	SIGNIN_WITH_GOOGLE,
	SIGNIN_WITH_FACEBOOK
} from '../constants/Auth';
import {
	showAuthMessage,
	authenticated,
	signOutSuccess,
	signUpSuccess,
	signInWithGoogleAuthenticated,
	signInWithFacebookAuthenticated,
	actualizar_photo,
	actualizarUserData
} from "../actions/Auth";

// import FirebaseService from 'services/FirebaseService'

import JwtAuthService from 'services/JwtAuthService'

// const callApi =  async (payload) => {
// 	const {email, password} = payload;

// 	JwtAuthService.login(JSON.stringify({
// 		usuario: email ,
// 		contrasena: password,
// 		id_institucion: 29
// 	})).then(user => user).catch(err => err);
// }

const callApi =  async (email,password,tipoLogin,dataLOG) => {
	// return await apiCall(...);
	let dataEscuela = JSON.parse( localStorage.getItem('dataEscuela')); 
	return await JwtAuthService.login({
		usuario: email ,
		contrasena: password,
		id_institucion: dataEscuela.id,
		tipoLogin,
		dataLOG
	}).then(user => user).catch(err => err);
}

const callApiGoogleAuth =  async (id_institucion,token) => {
	return await JwtAuthService.loginGoogle(id_institucion, token)
	.then(user => user)
	.catch(err => err);
}

const callARegister =  async (payload) => {
	// return await apiCall(...);
	let dataEscuela = JSON.parse( localStorage.getItem('dataEscuela')); 
	payload.role = 4;
	payload.i = dataEscuela.id;
	return await JwtAuthService.signUp(payload).then(user => user).catch(err => err);
}

const callApiIP = async()=>{
	const url =  "https://pro.ip-api.com/json?key=fK0gpJMT9WRwZuG";
	return fetch(url).then((resp) => resp.json())
	.then((data)=>{
		let objIpsLog = {
			ip :data.query,
			timezone: data.timezone,
			zip:data.zip,
			regionName:data.regionName,
			isp:data.isp,
			city:data.city,
			country:data.country,
			countryCode:data.countryCode,
		}
		return objIpsLog
	})
	.catch(function(error) {
	});
}

// const callLogin = async (email, password) =>
	// await auth.signInWithEmailAndPassword(email, password).then(user => user).catch(err => err);

export function* signInWithFBEmail() {
  yield takeEvery(SIGNIN,  function* ({payload}) {
		const {email, password,tipoLogin} = payload;
		try {


			
			const dataLOG = yield call(callApiIP)
			// const user = await callApi(payload);

			const user = yield call(callApi, email, password,tipoLogin,dataLOG);


			if (user.status) {
				// alert(user.token);
				 localStorage.setItem(AUTH_TOKEN, user.token);
				 localStorage.setItem("user_info", JSON.stringify(user.user));	
				 localStorage.setItem("imgProfile",user.user.data.photoURL);	

				 //SETEAR LA COOKIE LOGIN
				 var fecha = new Date();
				 fecha.setTime(fecha.getTime() + ('7' * 24 * 60 * 60 * 1000)); // Caduca en 'dias' días
				 var expires = "expires=" + fecha.toUTCString();
				 document.cookie = 'loginStatus' + "=" + 'true' + ";" + expires + ";path=/";
										 
				 yield put (actualizar_photo(user.user.data.photoURL));
				 yield put (actualizarUserData(user.user.data));

				yield put(authenticated(user.token));
			} else {
				yield put(showAuthMessage(user.message));
			}
		} catch (err) {
			yield put(showAuthMessage(err));
		}
	});
}


export function* signOut() {
	yield takeEvery(SIGNOUT, function* () {
		  try {
			let signOutUser  = undefined
			//   const signOutUser = yield call(FirebaseService.signOutRequest);
			  if (signOutUser === undefined) {
				document.cookie =  'loginStatus=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

				let idEscuela = JSON.parse(localStorage.getItem('dataEscuela'))["id"];
				// document.cookie = "favorite_food=tripe; SameSite=None; Secure";

				yield call(JwtAuthService.logout, idEscuela  );
				  localStorage.removeItem(AUTH_TOKEN);
				  localStorage.removeItem("user_info");
				  localStorage.removeItem("imgProfile");
				  yield put(signOutSuccess(signOutUser));
				// document.cookie = `cSchool-${idEscuela}` + '=;expires=Thu, 01 Jan 1999 00:00:01 GMT; ';
				// document.cookie = `cSchool-${JSON.parse(localStorage.getItem('dataEscuela'))["id"]}` + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
				// window.location = `https://api.facturasiempre.com//api/usuarios/logout?e=${idEscuela}`;

			  } else {
				  yield put(showAuthMessage(signOutUser.message));
			  }
		  } catch (err) {
			  yield put(showAuthMessage(err));
		  }
	  });
  }


export function* signUpWithFBEmail() {
//   yield takeEvery(SIGNUP, function* ({payload}) {
// 		const {email, password} = payload;
// 		try {
// 			const user = yield call(JwtAuthService.signUp, payload);
// 			console.log(user,'user')
// 			// if (user.message) {
// 			// 	yield put(showAuthMessage(user.message));
// 			// } else {
// 			// 	localStorage.setItem(AUTH_TOKEN, user.user.uid);
// 			// 	yield put(signUpSuccess(user.user.uid));
// 			// }
// 		} catch (error) {
// 			yield put(showAuthMessage(error));
// 		}
// 	}
// 	);
	yield takeEvery(SIGNUP,  function* ({payload}) {
		const {email, password,tipoLogin} = payload;
		try {


			

			const user = yield call(callARegister,payload);
			console.log(user,'user')

			if (user.status) {
				
			} else {
				yield put(showAuthMessage(user));
			}
		} catch (err) {
			yield put(showAuthMessage(err));
		}
	});
}

// export function* signInWithFBGoogle() {
//   yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
// 		try {
// 			const user = yield call(FirebaseService.signInGoogleRequest);
// 			if (user.message) {
// 				yield put(showAuthMessage(user.message));
// 			} else {
// 				localStorage.setItem(AUTH_TOKEN, user.user.uid);
// 				yield put(signInWithGoogleAuthenticated(user.user.uid));
// 			}
// 		} catch (error) {
// 			yield put(showAuthMessage(error));
// 		}
// 	});
// }

// export function* signInWithFacebook() {
//   yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
// 		try {
// 			const user = yield call(FirebaseService.signInFacebookRequest);
// 			if (user.message) {
// 				yield put(showAuthMessage(user.message));
// 			} else {
// 				localStorage.setItem(AUTH_TOKEN, user.user.uid);
// 				yield put(signInWithFacebookAuthenticated(user.user.uid));
// 			}
// 		} catch (error) {
// 			yield put(showAuthMessage(error));
// 		}
// 	});
// }

export function* signInWithFBGoogle() {
  yield takeEvery(SIGNIN_WITH_GOOGLE, function* ({payload}) {
		try {
			const {credential, id_institucion} = payload;
			// const user = null;
			const user = yield call(callApiGoogleAuth, id_institucion, credential);			
			if (user.status) {
				 localStorage.setItem(AUTH_TOKEN, user.token);
				 localStorage.setItem("user_info", JSON.stringify(user.user));	
				 localStorage.setItem("imgProfile",user.user.data.photoURL);					 		 
				 yield put (actualizar_photo(user.user.data.photoURL));
				 yield put (actualizarUserData(user.user.data));

				yield put(signInWithGoogleAuthenticated(user.token));
			} else {
				yield put(showAuthMessage(user.message));
			}

		} catch (error) {
			yield put(showAuthMessage(error));
		}
	});
}

export default function* rootSaga() {
  yield all([
		fork(signInWithFBEmail),
		fork(signOut),
		fork(signInWithFBGoogle),
		fork(signUpWithFBEmail),
		// fork(signInWithFBGoogle),
		// fork(signInWithFacebook)
  ]);
}
